"use client";

import { isDemo } from "@/lib/config";

/**
 * Small fixed badge shown only in demo environments.
 * Detects demo by hostname or config URL containing "demo".
 */
export function DemoBadge() {
  if (!isDemo()) return null;

  return (
    <div
      className="fixed left-0 top-0 z-[9999] select-none pointer-events-none"
      aria-hidden
    >
      <div className="bg-amber-500 text-black text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-br-md shadow-sm">
        demo
      </div>
    </div>
  );
}
